const isBanner = element =>  {
    return Object.keys(element)[0] === "Banner" || Object.keys(element)[0] === "MainHeader";
}

export default isBanner;